/**
 * Estructura para la información del usuario
 */
export class UserInformation {
    sellerId: string;
    sellerProfile: string;
    sellerName: string;
    sellerNit: string;
    sellerEmail: string;
}
